import { createElement } from './helpers'

let sojernScript = null

function toParamsString(params) {
  /* Please do not modify the below code. */
  var cid = []
  var paramsArr = []
  var cidParams = []
  // var pl = (this.pl = document.createElement('script'))
  var defaultParams = { vid: 'hot', et: 'hc' }

  for (const key in defaultParams) {
    params[key] = defaultParams[key]
  }

  for (const key in cidParams) {
    cid.push(params[cidParams[key]])
  }

  params.cid = cid.join('|')

  for (const key in params) {
    paramsArr.push(key + '=' + encodeURIComponent(params[key]))
  }

  return paramsArr.join('&')
}

function generateParameters(cart, property, search = true, bookingID = null) {
  const { address, name, id, currency } = property
  const { checkIn, checkOut, los } = cart

  const result = {
    hd1: checkIn,
    hd2: checkOut,
    hc1: address.city,
    hs1: address.countryCode,
    hpr: name,
    hpid: id,
    hd: los,
  }

  if (!search) {
    const item = cart.items[0]

    Object.assign(result, {
      hr: item.qty,
      hc: item.roomType,
      hp: item.price.net,
      hcu: currency,
      hrp: item.price.gross,
    })

    if (bookingID) {
      Object.assign(result, { hconfno: bookingID })
    }
  }

  return toParamsString(result)
}

function init(id, paramsString) {
  const script = createElement('script', {
    type: 'text/javascript',
    async: true,
    src: `https://beacon.sojern.com/pixel/p/${id}?f_v=v6_js&p_v=1&${paramsString}`,
  })

  sojernScript = document.head.appendChild(script)
}

export function search(cart, property) {
  init('256135', generateParameters(cart, property))
}

export function shoppingCart(cart, property) {
  init('256133', generateParameters(cart, property, false))
}

export function confirmation(cart, property, bookingID) {
  init('49033', generateParameters(cart, property, false, bookingID))
}

export function terminate() {
  if (sojernScript) {
    document.head.removeChild(sojernScript)
    sojernScript = null
  }
}

// export default class Sojern {
//   constructor() {
//     this.script = document.createElement('script')
//     this.scriptEl = null
//   }

//   init(id, params) {
//     /* Please do not modify the below code. */
//     var cid = []
//     var paramsArr = []
//     var cidParams = []
//     // var pl = (this.pl = document.createElement('script'))
//     var defaultParams = { vid: 'hot', et: 'hc' }

//     for (const key in defaultParams) {
//       params[key] = defaultParams[key]
//     }

//     for (const key in cidParams) {
//       cid.push(params[cidParams[key]])
//     }

//     params.cid = cid.join('|')

//     for (const key in params) {
//       paramsArr.push(key + '=' + encodeURIComponent(params[key]))
//     }

//     var paramsString = paramsArr.join('&')

//     this.script.type = 'text/javascript'
//     this.script.async = true
//     this.script.src = `https://beacon.sojern.com/pixel/p/${id}?f_v=v6_js&p_v=1&${paramsString}`

//     this.scriptEl = (
//       document.getElementsByTagName('head')[0] ||
//       document.getElementsByTagName('body')[0]
//     ).appendChild(this.script)

//     // var targetEl =
//     //   (document.getElementsByTagName('head')[0] ||
//     //   document.getElementsByTagName('body')[0]).appendChild(this.script)

//     // targetEl.appendChild(this.script)
//   }

//   initSearch(cart, property) {
//     this.init('256135', generateParameters(cart, property))
//   }

//   initShoppingCart(cart, property) {
//     this.init('256133', generateParameters(cart, property, false))
//   }

//   initConfirmation(cart, property, bookingID) {
//     this.init('49033', generateParameters(cart, property, false, bookingID))
//   }

//   terminate() {
//     const el =
//       document.getElementsByTagName('head')[0] ||
//       document.getElementsByTagName('body')[0]
//     console.log('el', el)
//     console.log('scriptel', this.scriptEl)
//     el.removeChild(this.scriptEl)
//     // if (this.script.parentNode) {
//     //   this.script.parentNode.removeChild(this.script)
//     // }
//     // document.head.removeChild(this.targetEl)
//   }
// }
